import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	titleMeet: {
		'id': 'freshMint.titleMeet',
		'defaultMessage': 'Meet FreshMint at Stog',
	},
	subtitleMeet: {
		'id': 'freshMint.subtitle',
		'defaultMessage': 'cutting-edge solution for growing of plenty kinds of plants.',
	},
	titleDefine: {
		'id': 'freshMint.titleDefine',
		'defaultMessage': 'Stog FreshMint is a sophisticated aeroponic growbox.',
	},
	subtitleDefine: {
		'id': 'freshMint.subtitleDefine',
		'defaultMessage': 'Choose how to grow. Find a room for a box. FreshMint will handle everything else',
	},
});





// WEBPACK FOOTER //
// ./src/components/LandingFreshMint/messages.js